/**
 * Логическое приложение и его развёртывания.
 *
 * Слой, которого не хватало между «что где стоит» и «что чем защищено».
 * Инвентарь отвечает на первый вопрос, матрица на второй, а третий — «сколько
 * у нас на самом деле магазинов» — не отвечал никто: три копии одного
 * магазина выглядели тремя разными сайтами.
 *
 * Разделение простое и повторяет то, где живёт знание.
 *
 *   манифест сайта   — где код, медиа и база. Знает тот, кто ведёт проект.
 *   манифест хоста   — какие проекты на машине. Знает тот, кто ведёт машину.
 *   ЭТОТ слой        — какие копии есть у приложения и какая основная.
 *                      Не факт, а РЕШЕНИЕ, и принимает его владелец.
 *
 * Машина, на которой стоит копия, не может знать, что она копия: спросить не
 * у кого. Даже собственный домен ничего не доказывает — сегодня
 * copy.eurobrands-shop.de, завтра тот же каталог отвечает на боевом домене.
 */

/**
 * Роль развёртывания. Меняется свободно; идентификатор — никогда.
 *
 * Идентификатор развёртывания это префикс в хранилище: переименование
 * означает брошенную историю. Роль — указатель, и переставить его ничего не
 * стоит. Отсюда и странное на вид сочетание, которое у нас уже есть:
 * развёртывание с именем «copy» в роли основного. Имя техническое, роль
 * настоящая, и путать их не надо.
 */
export const DEPLOYMENT_ROLES = ['primary', 'standby', 'staging', 'test', 'archive'] as const;
export type DeploymentRole = (typeof DEPLOYMENT_ROLES)[number];

export const ROLE_LABELS: Record<DeploymentRole, string> = {
  primary: 'основная',
  standby: 'резерв',
  staging: 'подготовка',
  test: 'проверочная',
  archive: 'архив',
};

/**
 * Насколько роль важна. Нужна для двух разных вещей, и обе существенные.
 *
 * Порядок на экране: основная копия первой, архив последним. И вес тревоги:
 * пропущенный проход у основной — происшествие, у проверочной — шум.
 * Одинаковая тревога на оба случая через месяц перестаёт читаться, и
 * пропущенной окажется настоящая.
 */
export const ROLE_WEIGHT: Record<DeploymentRole, number> = {
  primary: 0,
  standby: 1,
  staging: 2,
  test: 3,
  archive: 4,
};

/**
 * Вид приложения. Не для значка: по нему понятно, чего от приложения ждать.
 *
 * Определение, по которому вещь попадает в этот список: **есть интерфейс и
 * есть данные** — своя база или то, что оно порождает. Прокси и шлюз под него
 * не подходят: интерфейс есть, а терять нечего, всё восстанавливается
 * пересборкой. Именно поэтому их здесь нет и не должно быть.
 */
export const SERVICE_KINDS = ['web', 'erp', 'pbx', 'mail', 'portal', 'search', 'other'] as const;
export type ServiceKind = (typeof SERVICE_KINDS)[number];

export const SERVICE_KIND_LABELS: Record<ServiceKind, string> = {
  web: 'Сайт',
  erp: 'Учётная система',
  pbx: 'Телефония',
  mail: 'Почта',
  portal: 'Портал',
  search: 'Поиск',
  other: 'Прочее',
};
